import { Injectable } from '@angular/core'
import { UserModel } from '../../../models/user.model'
import { PageEvent } from '@angular/material'
import { Observable } from 'rxjs/Observable'
import { UserResponse } from '../../../models/user-response'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { BehaviorSubject } from 'rxjs/BehaviorSubject'

@Injectable()
export class AdminUsersService {
  private readonly url = environment.base_url + '/v1/administration'
  private filters: any

  users: UserModel[]
  user: UserModel

  onUsersChanged: BehaviorSubject<any> = new BehaviorSubject(UserResponse)
  onUserChanged: BehaviorSubject<any> = new BehaviorSubject(undefined)
  onFilterChanged: BehaviorSubject<any> = new BehaviorSubject('')

  constructor(private http: HttpClient) {
    this.users = []
    this.filters = {
      paginated: true,
    }
  }

  /**
   * Get list of users
   * @returns {Observable<Array<UserModel>>}
   */
  public list(administrationId: number): Observable<any> {
    return this.http.get(`${this.url}/${administrationId}/users`, { params: this.filters })
  }

  /**
   * Update a User
   * @param {UserModel} user
   * @returns {Observable<UserModel>}
   */
  public update(user: UserModel): Observable<UserModel> {
    return this.http.put<UserModel>(`${this.url}/${user.id}`, user)
  }

  /**
   * Delete a User
   * @param {UserModel} user
   * @returns {Observable<UserModel>}
   */
  public delete(user: UserModel): Observable<UserModel> {
    return this.http.delete<UserModel>(`${this.url}/${user.id}`)
  }

  /**
   * Resend activation link
   * @param {UserModel} user
   * @returns {Observable<UserModel>}
   */
  public resendActivation(user: UserModel): Observable<UserModel> {
    return this.http.patch<UserModel>(`${this.url}/${user.id}/resend-activation`, {})
  }

  /**
   * (un)Blocks a user
   * @param {UserModel} user
   * @returns {Observable<UserModel>}
   */
  public block(user: UserModel): Observable<UserModel> {
    return this.http.patch<UserModel>(`${this.url}/${user.id}/block`, {})
  }

  usersChanged(userResponse: UserResponse) {
    this.onUsersChanged.next(userResponse)
  }

  changeSearch(search: string) {
    this.filters.search = search
    this.onFilterChanged.next(this.filters)
  }

  changeFilter(event?: PageEvent) {
    this.filters.page = event.pageIndex + 1
    this.filters.limit = event.pageSize
    this.onFilterChanged.next(this.filters)
  }

  changeRole(role) {
    this.filters.role = role
    this.onFilterChanged.next(this.filters)
  }

  changeState(state) {
    this.filters.status = state
    this.onFilterChanged.next(this.filters)
  }

  clearFilter() {
    this.filters = {
      paginated: true,
    }
    this.onFilterChanged.next(this.filters)
  }

  /**
   * setting the current administration
   * @param user
   */
  setCurrentUser(user: UserModel) {
    this.user = user
    this.onUserChanged.next(user)
  }

  /**
   * setting the current administration
   */
  unSetCurrentUser() {
    this.user = undefined
    this.onUserChanged.next(this.user)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/ledger/services/admin-users.service.ts